import React from 'react';
import styles from './FloatingSubmitButton.module.scss';
import SubmitButton, {
	SubmitButtonProps,
} from '../../../../Components/Button/SubmitButton';
import { FieldValues } from 'react-hook-form';

const FloatingSubmitButton = <T extends FieldValues = FieldValues>(
	props: SubmitButtonProps<T>,
) => {
	return (
		<div className={styles.wrapper}>
			<SubmitButton {...props} />
		</div>
	);
};

export default FloatingSubmitButton;
